import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'prcins-mobile-app-landing',
  templateUrl: './mobile-app-landing.component.html',
  styleUrls: ['./mobile-app-landing.component.css']
})
export class MobileAppLandingComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }
}
